import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export const avatarsKey = ['avatars'] as const;

// One small list of who has a photo, shared by every avatar on screen, so the
// browser only fetches images that exist and initials stay for everyone else.
export function useAvatarUrl(personId: string | undefined): string | null {
  const query = useQuery({
    queryKey: avatarsKey,
    queryFn: () => api.listAvatars(),
    enabled: personId !== undefined,
    staleTime: 5 * 60_000,
    retry: false,
  });
  if (!personId || !query.data) return null;
  const version = query.data.find((a) => a.personId === personId)?.version;
  return version ? api.avatarUrl(personId, version) : null;
}
